import { DisplayBanner } from "../banner/bannerSlice";
import { redirectAction } from "../redux/routerRedirect/reduxRouterRedirectMiddleware";

export const createDeleteTeamsWorkflowSuccess = (
  teamName: string | undefined
): DisplayBanner => ({
  type: "success",
  header: "System task submitted",
  content: `${teamName} is being deleted. View the status on your system tasks page.`,
  buttonText: "View system tasks",
  onButtonClick: redirectAction("/system-tasks/"),
  dissmissible: true,
});

export const deleteTeamSuccess = (
  teamName: string | undefined
): DisplayBanner => ({
  type: "success",
  content: `The team ${teamName} has been deleted successfully.`,
  dissmissible: true,
});

export const deleteTeamAccepted = (
  teamName: string | undefined
): DisplayBanner => ({
  type: "success",
  content: `The team ${teamName} has been deleted. This change may take a while to be reflected in Crew and Roster 2.0.`,
  dissmissible: true,
});
